// extracted by mini-css-extract-plugin
module.exports = {"mobile-whiteboard":"mobile-whiteboard___GUsA9","loading":"loading___1ZdEG"};